export const getTheme = (state) => state.theme
export const getLayoutType = (state) => state.theme.layout.type
export const getThemeColor = (state) => state.theme.themeColor
export const getPrimaryColorLevel = (state) => state.theme.primaryColorLevel
export const getNavMode = (state) => state.theme.navMode
export const getMode = (state) => state.theme.mode
export const getDirection = (state) => state.theme.direction
export const getCurrentRouteKey = (state) => state.base.common.currentRouteKey
